export default __webpack_public_path__ + "static/media/modal-bg.3a4b0073.svg";